import { Alert, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const ExecutionScopeAlert = ({ projectId }) => {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <Typography variant="body2">
        No testing platforms have been defined in the execution scope. Defining them
        will improve testing coverage and efficiency. Configure them in{' '}
        <Link
          to={`/project/${projectId}/configurations?tab=scope`}
          target="_blank">
          <strong>Project Configurations</strong>
        </Link>{' '}
        .
      </Typography>
    </Alert>
  );
};

export default ExecutionScopeAlert;
